import { render, staticRenderFns } from "./RziPhotos.vue?vue&type=template&id=abb0bfac&scoped=true&"
import script from "./RziPhotos.vue?vue&type=script&lang=js&"
export * from "./RziPhotos.vue?vue&type=script&lang=js&"
import style0 from "./RziPhotos.vue?vue&type=style&index=0&id=abb0bfac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb0bfac",
  null
  
)

export default component.exports